// extracted by mini-css-extract-plugin
export default {"headline":"headline_headline__-Mi7L"};